import styled from 'styled-components';

export const OptionContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  > div:first-child {
    display: flex;
    flex-direction: column;
    overflow: hidden;

    span {
      overflow: hidden;
      text-overflow: ellipsis;

      &.subtext {
        font-size: 14px;
        color: gray;
      }
    }
  }

  > div:last-child {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
